export default __webpack_public_path__ + "assets/images/cc9a34ee11cba91b98b2dc682dd34d75.svg";